import { CmsSeparatorProps } from '~/types/Cms';

const CmsSeparator = ({ data }: CmsSeparatorProps) => {
  const separatorStyle = data.style || 'solid';
  const separatorThickness = data.thickness || 'medium';
  const hiddenClass = data.hidden ? 'invisible' : '';
  const elementBorderStyle = {
    borderTopStyle: separatorStyle,
  };

  const borderThicknessMap = {
    fine: 'border-1',
    medium: 'border-2',
    thick: 'border-4',
    'very-thick': 'border-5',
  };
  const elementThicknessClass = borderThicknessMap[separatorThickness];

  return <div style={elementBorderStyle} className={`p-2 border-dark ${elementThicknessClass} ${hiddenClass}`} />;
};

export default CmsSeparator;
